<template>
  <div style="padding: 10px;">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-10">
          <h4>Gestores</h4>
        </div>
        <div class="col-md-2">
          <button
            class="btn btn-success"
            @click="cadastro()"
            style="margin-right: 5px; 
                  border-color: rgb(0, 150, 136); color: rgb(0, 150, 136);margin-top: 21px;float: right;margin-right: 22px;"
          >Cadastrar</button>
        </div>
      </div>
    </div>

    <div class="col-md-12" v-if="sucessoDelete">
        <div class="card" style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 20px !important;" >
            <div class="card-body">
                <div class="row">
                  <div class="col-md-4" >
                      {{sucessoDelete}}
                  </div>
                </div>
            </div>  
        </div> 
    </div>
    <div class="col-md-12" v-if="result_detalhes" style="transition-duration: 2.2s,.2s;">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">Nome: {{result_detalhes.nome}}</div>
            <div class="col-md-12">email: {{result_detalhes.email}}</div>
            <div class="col-md-12">Tipo: {{result_detalhes.tipo}}</div>
            <div
              class="col-md-12"
              v-if="result_detalhes.departamento"
            >Departamento: {{result_detalhes.departamento}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <vue-good-table
        :columns="columns"
        :rows="users"
        :lineNumbers="false"
        :search-options="{
          enabled: true,
          placeholder: 'Pesquisar',
        }"
        :pagination-options="{
              enabled: true,
              mode: 'records',
              mode: 'pages',
              perPage: 5,
              position: 'bottom',
              perPageDropdown: [5, 10, 15],
              dropdownAllowAll: false,
              nextLabel: 'Próximo',
              prevLabel: 'Anterior',
              rowsPerPageLabel: 'Linhas por página',
              ofLabel: 'de',
              pageLabel: 'pagina', 
              allLabel: 'All',
        }"
      >
        <template slot="table-row" slot-scope="props">

          <div v-if="props.column.field == 'status'">
            <switch-button
              v-model="props.row.status"
              color="#253DB9"
              :meuid="props.row.id"
              modulo="usuario"
              funcao="exibirStatus"
              v-if="user.tipo == 1 || user.tipo == 2"
            ></switch-button>
          </div>


          <span v-if="props.column.field == 'action'">
            <button
              class="btn btn-success"
              @click="detalhes(props.row.id)"
              style="margin-right: 5px; 
                border-color: rgb(0, 150, 136); color: rgb(0, 150, 136);"
              
            >
              <i class="fa fa-eye"></i>
            </button>
            <button class="btn btn-primary" @click="editar(props.row)" style="margin-right:5px;" >
              <i class="fa fa-pencil-square-o"></i>
            </button>
            <button class="btn btn-danger" @click="delete_option(props.row.id)" >
              <i class="fa fa-times"></i>
            </button>
          </span>
          <!--<span v-else>
                   {{props.formattedRow[props.column.field]}}
          </span>-->
          <span v-else>
            <span v-if="props.column.field != 'status'">{{props.formattedRow[props.column.field]}}</span>
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import axios from "axios";
import store from "src/store.js";
import "src/controller/sistema/usuarioController.js";
import SwitchButton from "src/components/switch.vue";

export default {
  name: "my-component",
  components: {
    VueGoodTable,
    SwitchButton,
  },
  data() {
    return {
      columns: [
        {
          label: "Usuario",
          field: "nome",
        },
        {
          label: "Email",
          field: "email",
        },
        {
          label: "Tipo",
          field: "tipo",
        },
        {
          label: "Unidade Organizacional",
          field: "departamento",
          hidden: true,
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Ações",
          field: "action",
          sortable: false,
        },
        {
          label: "id",
          field: "id",
          hidden: true,
        },
      ],
      usuarios: [],
      users: [],
      result_detalhes: null,
      sucessoDelete:null,
      tipo_usuario:[],
      user: {
        admin: null,
        admin_sistema: null,
        id: null,
        departamento:null,
        tipo: null,
      },
    };
  },
  methods: {
    cadastro(){
      this.$router.push({ name: "usuarioCadastrar" });
    },
    async delete_option(id) {
      try {
        
        this.$confirm("Deseja excluir?").then(() => {
          this.deletar(id);
        });
      } catch (e) {
        
      }
    },
    async deletar(id){
      try {
        let me = await this.$me();
        let data = await this.$usuarioDelete(id,me.id);
        if(data.data == "Deletado com Sucesso!"){
          this.sucessoDelete = data.data;
        }

        this.users = [];
        this.listarTudo();
       } catch (e) {
        
      }
    },
    detalhes(id) {
      let detalhe_user = [];
      this.users.forEach((element) => {
        if (id == element.id) {
          detalhe_user = element;
        }
      });
      this.result_detalhes = detalhe_user;
    },
    editar(row) {
      this.$router.push({ name: "usuarioEditar", params: { row: row } });
    },
    async listarTudo() {
      try {
        let data = await this.$listarAdminEsuper();
        this.usuarios = data.data.reverse();

        let s = await this.$secretaria();
        let secretarias = s.data;
        
        this.usuarios.forEach((array) => {
          this.filtro(array, secretarias,this.tipo_usuario);
        });
      } catch (e) {}
    },
    async filtro(array, secretarias, tipo_usuario) {
      try {
        let departamento;
        let tipo_nome;
        let tipo_id;
        let status;

        /*secretarias.forEach((element) => {
          if (array.departamento == element.id) {
            departamento = element.secretaria;
          }
        });*/

        let dep = array.departamento.split('-');
        if(dep[0] == ''){
          dep.shift();
        }
        array.departamento = dep

        tipo_usuario.forEach(el => {
          if(el.id == array.tipo){
            tipo_nome =el.nome;
            tipo_id =el.id;
          }
        });

        if (array.status == 1) {
          status = true;
        } else {
          status = false;
        }
        
        let user;

        if(this.user.departamento != 0){
          if(tipo_nome != 'ADM'){
            user = {
              id: array.id,
              nome: array.name,
              email: array.email,
              tipo: tipo_nome,
              grupo_id: array.grupo,
              tipo_id: tipo_id,
              departamento: array.departamento,
              gestor_cpf: array.gestor_cpf,
              status: status,
            };
            this.users.push(user);
          }
        }else{
          user = {
            id: array.id,
            nome: array.name,
            email: array.email,
            tipo: tipo_nome,
            grupo_id: array.grupo,
            tipo_id: tipo_id,
            departamento: array.departamento,
            gestor_cpf: array.gestor_cpf,
            status: status,
          };
          this.users.push(user);
        }
        

      } catch (e) {
         console.log(e)
      }
    },
    async tipoUsuario(){
      let data = await this.$listarTiposUsuario();
      this.tipo_usuario = data.data;
    }
  },
  async beforeMount() {
    try {
      this.user.departamento = store.departamento;
      await this.tipoUsuario();
      await this.listarTudo();
      this.user.admin = store.admin;
      this.user.admin_sistema = store.admin_sistema;
      this.user.id = store.id;
      this.user.tipo = store.tipo;
    } catch (e) {}
  },
};
</script>

